import { render, staticRenderFns } from "./AdvertGroup.vue?vue&type=template&id=5b9436ac&scoped=true&"
import script from "./AdvertGroup.vue?vue&type=script&lang=js&"
export * from "./AdvertGroup.vue?vue&type=script&lang=js&"
import style0 from "./AdvertGroup.vue?vue&type=style&index=0&id=5b9436ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9436ac",
  null
  
)

export default component.exports